import React, { useState } from "react";
import axios from "axios";

import API from "../config/API";
import "../publicUsersPages/Payments.css";

const PaymentPage = () => {
  const [loading, setLoading] = useState(false);

  // =====================================================
  // CREATE RAZORPAY ORDER
  // =====================================================
  const createOrder = async () => {
    try {
      setLoading(true);

      const request = {
        bookingId: 47,
        userId: 1,
        amount: 7000,
      };

      // Dynamic API URL
      const createOrderUrl = `${API.V2}/payment/create-order`;

      console.log("Create Order API:", createOrderUrl);
      console.log("Create Order Request:", request);

      const response = await axios.post(createOrderUrl, request, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Create Order Response:", response.data);

      if (response.data?.statusCode !== 200) {
        alert(response.data?.message || "Unable to create payment order");
        setLoading(false);
        return;
      }

      openCheckout(response.data.data);
    } catch (error) {
      console.error("Create Order Error:", error);
      console.error("Error Response:", error.response?.data);

      alert(error.response?.data?.message || "Unable to create payment order");

      setLoading(false);
    }
  };

  // =====================================================
  // OPEN RAZORPAY CHECKOUT
  // =====================================================
  const openCheckout = (payment) => {
    const options = {
      key: payment.key,

      amount: payment.amount,

      currency: payment.currency,

      order_id: payment.orderId,

      name: "SVK PG",

      description: "PG Room Booking",

      image: "",

      handler: async function (response) {
        console.log("Payment Success");
        console.log("Razorpay Response:", response);

        await verifyPayment(response);
      },

      prefill: {
        name: "Madhu",
        email: "madhu@gmail.com",
        contact: "9876543210",
      },

      notes: {
        bookingId: 47,
      },

      theme: {
        color: "#3399cc",
      },

      modal: {
        ondismiss: function () {
          alert("Payment Cancelled");
        },
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.open();

    setLoading(false);
  };

  // =====================================================
  // VERIFY PAYMENT
  // =====================================================
  const verifyPayment = async (paymentResponse) => {
    try {
      const request = {
        razorpayOrderId: paymentResponse.razorpay_order_id,

        razorpayPaymentId: paymentResponse.razorpay_payment_id,

        razorpaySignature: paymentResponse.razorpay_signature,
      };

      // Dynamic API URL
      const verifyPaymentUrl = `${API.V2}/payment/verify`;

      console.log("Verify Payment API:", verifyPaymentUrl);
      console.log("Verify Payment Request:", request);

      const response = await axios.post(verifyPaymentUrl, request, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Verify Payment Response:", response.data);

      if (response.data?.statusCode === 200) {
        alert("Payment Successful");
      } else {
        alert(response.data?.message || "Payment Verification Failed");
      }
    } catch (error) {
      console.error("Payment Verification Error:", error);
      console.error("Verification Error Response:", error.response?.data);

      alert(error.response?.data?.message || "Verification Failed");
    }
  };

  // =====================================================
  // UI
  // =====================================================
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <button
        onClick={createOrder}
        disabled={loading}
        style={{
          background: "#3399cc",
          color: "white",
          border: "none",
          padding: "15px 30px",
          borderRadius: "8px",
          cursor: loading ? "not-allowed" : "pointer",
          fontSize: "18px",
        }}
      >
        {loading ? "Please Wait..." : "Pay ₹7000"}
      </button>
    </div>
  );
};

export default PaymentPage;
